<template>
  <div id="usertransactions">
    <v-container class="fill-height" fluid>
      <v-row  justify="center">
        <h1> User Transactions</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row >
        <router-link :to="'/admin/users-list'">Back</router-link>
      </v-row>
    </v-container>
    <v-container
      class="grey lighten-5 mb-6"
    >
      <v-row>
        <v-col md="1" sm="6">
          <v-card
            class="pa-2"
            outlined
            tile
          >
            Name
          </v-card>
        </v-col>
        <v-col md="2" sm="6">
          <v-card
            class="pa-2"
            outlined
            tile
          >
         {{name }}
          </v-card>
        </v-col>
        <v-col md="1" sm="6">
          <v-card
            class="pa-2"
            outlined
            tile
          >
            Email
          </v-card>
        </v-col>
        <v-col md="3" sm="6">
          <v-card
            class="pa-2"
            outlined
            tile
          >
           {{ email}}
          </v-card>
        </v-col>
        <v-col md="2" sm="6">
          <v-card
            class="pa-2"
            outlined
            tile
          >
            DammN ID
          </v-card>
        </v-col>
        <v-col md="3" sm="6">
          <v-card
            class="pa-2"
            outlined
            tile
          >
           {{dannNId}}
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-card>
    <v-tabs
      v-model="tab"
      background-color="black"
      dark
    >
      <v-tab
        v-for="item in tabs"
        :key="item.key"
        @change="onTabChange(item.key)"
       
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in tabs"
        :key="item.key"
      >
       <!-- <v-card flat>
          <v-card-text>{{ item.content }}</v-card-text>
        </v-card>-->
         <v-card>
          <v-data-table
            :headers="headers"
            :items="transactions"
            :search="search"
            :items-per-page="20"
          >
            <template v-slot:item.created_at="{ item }">
              <h4>{{ item.created_at | moment('timezone', timezone, " h:mm:ss a") }}</h4>
              {{ item.created_at | moment('timezone', timezone, " Do MMMM YYYY") }}
            </template>
            <template
              v-slot:item.name="{ item }"
            >{{ item.user.firstname + ' ' + item.user.lastname }}</template>
            <template v-slot:item.amount="{ item }">${{ (item.amount/100).toFixed(2) }}</template>
            <template v-slot:item.balance="{ item }">${{ (item.balance/100).toFixed(2) }}</template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
    
    <v-card>


   
        <v-card flat>
          
        </v-card>
     
  </v-card>

    </v-container>
   
  </div>
</template>

<script>
export default {
  name: "Transactions",
  data() {
    return {
      search: "",
      name:"",
      email:"",
      dannNId:"",
      tab: "",
      key:"",
      transactions: [],
      alignments: [
        'start',
        'center',
        'end',
      ],
      headers: [
        { text: "Date", value: "created_at", align: "start" },
        { text: "App type", value: "app_type" },
        { text: "Amount", value: "amount" },
        { text: "Reference", value: "reference" },
        { text: "Type", value: "type" },
        { text: "Balance", value: "balance" },
        { text: "Category", value: "category" },
        { text: "Description", value: "description" }
      ],
       tabs: [
          { tab: 'All',key:"all", content: 'Tab 6 Content' },
          { tab: 'Myyaak',key:"myyaak", content: 'Tab 1 Content' },
          { tab: 'Quizstar',key:"quizstar", content: 'Tab 2 Content' },
          { tab: 'Sportstrade',key:"sportstrade", content: 'Tab 3 Content' },
          { tab: 'Risk',key:"risk", content: 'Tab 4 Content' },
          { tab: 'Pi3ck',key:"pi3ck", content: 'Tab 5 Content' },
          { tab: 'Mynews24',key:"mynews24", content: 'Tab 6 Content' },
          
          
        ],
        
    };
  },
  mounted() {
    this.getTransactions('all');
    this.getTimezone();
  },
  computed: {
    //console.log(this.tab)
  },
  methods: {
      onTabChange(key) {
     this.transactions= [];
     this.tab=key;
     this.getTransactions(key);
    
   },
    getTransactions(key) {
     
      if (this.transactions == "undefined" || this.transactions.length < 1) {
        this.$store.dispatch("retrieveuserTransactions",{userid:this.$route.params.userid,app_type:key}).then(() => {
          this.transactions = this.$store.getters.userTransactions;
          this.tab= this.$store.getters.userTransactions;
          this.name = this.$store.getters.userTransactions[0].user.firstname +' '+ this.$store.getters.userTransactions[0].user.lastname;
          this.email = this.$store.getters.userTransactions[0].user.email ; 
          this.dannNId = this.$store.getters.userTransactions[0].user.damnnId ; 
        });

      }
    },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    }
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}
</style>